// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var ChevronLeft = function ChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.693 2.306a1.04 1.04 0 0 1 0 1.475L7.45 10l6.244 6.219a1.04 1.04 0 0 1 0 1.475 1.05 1.05 0 0 1-1.482 0l-6.984-6.956a1.04 1.04 0 0 1 0-1.476l6.984-6.956a1.05 1.05 0 0 1 1.482 0",
    clipRule: "evenodd"
  }));
};
